import React from 'react';
import '../css/info.css';
import { Container } from 'react-bootstrap';

const Topbar = () => {
  return (
    <div className="top-divs">
      <Container>
        <div className="top-bars">
          {/* Left Section */}
          <div className="top-item">
            <i className="fas fa-map-pin icon"></i>
            <a
              className="links"
              href="https://www.google.com/maps/search/?api=1&query=Chak+248+RB+Bismillahpur+Pakistan"
              target="_blank"
              rel="noopener noreferrer"
            >
              Chak 248 RB Bismillahpur, Pakistan
            </a>
          </div>

          {/* Right Section */}
          <div className="top-item">
            <span className="phones">Call Now!</span>
            <a className="links" href="tel:+923206686696">
              0320-6686696
            </a>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Topbar;
